/**
 * The INLINE alert levels. A rule stores the level a feature must reach in its
 * `impact_p90` attribute, and a notification's matched feature carries the level it
 * actually reached in `properties.impact_p90`. The names double as the `edera-label-*`
 * CSS class suffix (see InlineRules.css).
 */
export const IMPACT_LEVELS: { name: string, value: number }[] = [
    { name: "Low", value: 1 },
    { name: "Medium", value: 2 },
    { name: "High", value: 3 },
    { name: "Extreme", value: 4 },
];

/** The name of the alert level for a raw `impact_p90` value, which can be fractional. */
export function impactLevelName(impact: number | undefined | null): string | null {
    if (impact === undefined || impact === null) {
        return null;
    }

    return IMPACT_LEVELS.find((level) => level.value === Math.floor(impact))?.name ?? null;
}
